import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  createToken,
  selectLoading,
  selectInfo,
  selectTokenCreating,
  selectTokenError,
} from '../../features/profile/profileSlice';

import { Button, Typography, Space, Card } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';

import { Spinner } from '../../components/Spinner';
import './ApiKeys.scss';

export const ApiKeys = () => {
  const dispatch = useDispatch();

  const { apiTokens } = useSelector(selectInfo);

  const tokenCreating = useSelector(selectTokenCreating);
  const tokenError = useSelector(selectTokenError);

  function onCreateToken() {
    dispatch(createToken());
  }

  const loading = useSelector(selectLoading);
 
  if (loading) {
    return (
      <Spinner />
    );
  }

  return (
    <div className="c-api-keys">
      <Typography.Title level={4} style={{ textAlign: 'center' }}>API Keys:</Typography.Title>
      <Space direction="vertical" size="small" style={{ display: 'flex' }}>
        {
          apiTokens?.map((token) => (
            <Card size="small" className="c-api-keys__token-card" key={token}>
              <Typography.Paragraph copyable>{ token }</Typography.Paragraph>
            </Card>
          ))
        }
      </Space>
      <div className="styles.error">{ tokenError }</div>
      <div style={{ padding: '25px 0', textAlign: 'center'}}>
        <Button type="primary" icon={<PlusCircleOutlined />} loading={ tokenCreating } onClick={ onCreateToken }>Create New</Button>
      </div>
    </div>
  );
}